function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.563 7.458V14H1.875a.937.937 0 01-.938-.935V7.458h5.626zm7.5 0v5.607c0 .516-.42.935-.938.935H8.437V7.458h5.626zM8.87.553c.734-.736 2.014-.738 2.75 0a1.95 1.95 0 010 2.75c-.128.128-.31.272-.524.417h2.967c.517 0 .937.42.937.935v1.401c0 .258-.21.468-.469.468H8.438v-1.87H6.562v1.87H.47a.469.469 0 01-.469-.468V4.655c0-.515.42-.935.938-.935h2.966a3.679 3.679 0 01-.524-.418 1.951 1.951 0 010-2.749c.735-.736 2.015-.736 2.75 0C6.537.96 7.615 2.615 7.467 3.72h.068C7.385 2.615 8.464.96 8.871.553zM4.756.917a.994.994 0 00-.71.295 1.017 1.017 0 000 1.432c.403.405 1.64 1.076 2.288 1.076.134 0 .173-.03.173-.03.219-.226-.41-1.845-1.041-2.478a1 1 0 00-.71-.295zm6.199.295a1.025 1.025 0 00-1.42 0c-.632.633-1.26 2.252-1.042 2.477 0 .001.04.031.172.031.65 0 1.886-.67 2.29-1.076a1.017 1.017 0 000-1.432z",
  fill: "#747474",
  fillRule: "evenodd"
});

function SvgVoucher(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14,
    viewBox: "0 0 15 14"
  }, props), _ref);
}

export default SvgVoucher;